import { render, staticRenderFns } from "./AccountBranding.vue?vue&type=template&id=d23a8c76&"
import script from "./AccountBranding.vue?vue&type=script&lang=js&"
export * from "./AccountBranding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports